import { render, staticRenderFns } from "./MissingJobDescriptionNotification.vue?vue&type=template&id=6a87b0d4&scoped=true"
import script from "./MissingJobDescriptionNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./MissingJobDescriptionNotification.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MissingJobDescriptionNotification.vue?vue&type=style&index=0&id=6a87b0d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a87b0d4",
  null
  
)

export default component.exports